<div class="timeline-dialog-container">
    <!-- Filters Section -->
    <div class="filters-section mb-4 p-3 surface-100 border-round">
        <div class="flex flex-column gap-3">
            <!-- Search -->
            <div class="p-input-icon-left w-full">
                <i class="pi pi-search"></i>
                <input 
                    type="text" 
                    pInputText 
                    [(ngModel)]="searchText"
                    placeholder="Search timeline..."
                    class="w-full" />
            </div>
            
            <!-- Type Filter -->
            <p-multiselect
                [(ngModel)]="selectedTypes"
                [options]="typeOptionsForMultiselect"
                optionLabel="label"
                optionValue="value"
                placeholder="Filter by type"
                [showClear]="true"
                styleClass="w-full">
            </p-multiselect>
            
            <!-- Actions -->
            <div class="flex justify-content-between">
                <button 
                    pButton 
                    class="p-button-text p-button-sm"
                    (click)="clearFilters()">
                    <fa-icon [icon]="['fas', 'filter-circle-xmark']" class="mr-2"></fa-icon>
                    Clear
                </button>
                <button 
                    pButton 
                    class="p-button-text p-button-sm"
                    (click)="refresh()">
                    <fa-icon [icon]="['fas', 'sync']" class="mr-2"></fa-icon>
                    Refresh
                </button>
            </div>
        </div>
    </div>
    
    <!-- Timeline Content -->
    <div class="timeline-content" style="max-height: calc(100vh - 300px); overflow-y: auto;">
        @if (loading()) {
            <div class="flex justify-content-center align-items-center" style="height: 200px;">
                <p-progressspinner></p-progressspinner>
            </div>
        } @else {
            @if (filteredItems().length === 0) {
                <div class="text-center py-5">
                    <fa-icon [icon]="['fas', 'inbox']" class="text-4xl text-400"></fa-icon>
                    <p class="mt-3 text-600">
                        @if (timelineItems().length === 0) {
                            No timeline events found
                        } @else {
                            No events match your filters
                        }
                    </p>
                </div>
            } @else {
                <div class="timeline-wrapper">
                    @for (item of filteredItems(); track item.id) {
                        <div class="timeline-event">
                            <div class="timeline-event-marker flex align-items-center justify-content-center" 
                                 [style.backgroundColor]="item.iconColor">
                                <fa-icon [icon]="['fas', item.icon || 'info-circle']" class="text-white"></fa-icon>
                            </div>
                            <div class="timeline-event-connector"></div>
                            <div [class]="getItemClass(item)" class="timeline-content-item">
                                <!-- Header -->
                                <div class="timeline-item-header mb-2">
                                    <div class="font-semibold text-900">{{ item.title }}</div>
                                    <div class="text-500 text-sm">
                                        {{ formatDate(item.timestamp) }}
                                    </div>
                                </div>
                                
                                <!-- User Info -->
                                @if (item.user && item.user.name) {
                                    <div class="text-600 text-sm mb-2">
                                        <fa-icon [icon]="['fas', 'user']" class="mr-1"></fa-icon>
                                        {{ item.user.name }}
                                    </div>
                                }
                                
                                <!-- Content -->
                                @if (item.content) {
                                    <div class="timeline-body">
                                        @if (item.type === 'state_change') {
                                            <div class="state-transition p-2 surface-100 border-round">
                                                <span class="text-700">{{ item.content }}</span>
                                            </div>
                                        } @else if (item.type === 'note') {
                                            <div class="note-content p-2 surface-50 border-round preserve-linebreaks">{{ item.content }}</div>
                                        } @else {
                                            <div class="text-700 preserve-linebreaks">{{ item.content }}</div>
                                        }
                                    </div>
                                }
                                
                                <!-- Metadata -->
                                @if (item.metadata?.eventType || item.metadata?.noteType) {
                                    <div class="mt-2">
                                        <span class="p-tag p-tag-info text-xs">
                                            @if (item.metadata?.noteType) {
                                                {{ item.metadata!.noteType | databaseStringToHuman }}
                                            } @else {
                                                {{ item.type | databaseStringToHuman }}
                                            }
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        }
</div>